
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AppCommonModule } from 'src/app/common.module';
import { DashboardViewComponent } from 'src/app/components/views/dashboard/view-dashboard.component';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-partner-menu-page',
  templateUrl: './menu.page.html',
  styleUrls: ['./menu.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    DashboardViewComponent,
  ],
})
export class PartnerMenuPage {
  private navigationService = inject(NavigationService);

  onContracts() {
    this.navigationService.navigate(['/partner', 'contracts']);
  }

  onOffers() {
    this.navigationService.navigate(['/partner', 'offers']);
  }
}
